module.exports = __webpack_public_path__ + "static/media/view-modes.31324b88.png";